import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { FileServerLocation } from 'app/model/dataset/location/file-server.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FileServerLocation)
})
export class FileServerLocationAdapter extends FileLocationAdapter<FileServerLocation, Model.DatasetLocation> {
    public _toResource(store: FileServerLocation): Model.FileServerLocation {
        const resource: Model.FileServerLocation = {
            type: 'FileServerLocation',
            fileName: ValueAdapter.toResource(store, FileServerLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, FileServerLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.FileServerLocation, owner: Named): FileServerLocation {
        const model = Owned.create<FileServerLocation>(FileServerLocation.MODEL, owner);
        ValueAdapter.toModel(model, FileServerLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, FileServerLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
